import { makeModule } from "@/store/utils"
import { pluck } from "@/utils/functions"
import { make } from "vuex-pathify"
import { asSequence } from "sequency"

const sortedBy = (arr, key) => asSequence(arr)
	.sortedBy(pluck(key))
	.toArray();

const state = {
	diameters: [/* {
		id: 0,
		diameter: 1.2,
	}, {
		id: 1,
		diameter: 10.2,
	} */],
	norms: [/* {
		norm_id: 0,
		norm: "norm #0",
	}, {
		norm_id: 1,
		norm: "norm #1",
	} */],
	diameterKey: "id",
	diameterLabel: "diameter",
	normKey: "id",
	normLabel: "name",
};

const getters = {
	...make.getters(state),
	hasDiameters(state){
		return !!state.diameters.length;
	},
	hasNorms(state){
		return !!state.norms.length;
	},
};

const mutations = {
	...make.mutations(state),
};

const actions = {
	...make.actions(state),
	async LOAD_DIAMETERS({ getters, commit }, { vm }){
		if(getters.hasDiameters)
			return;

		try{
			const diameters = await vm.$json.get("/api/diameter/all");
			commit("SET_DIAMETERS", sortedBy(diameters, getters.diameterLabel));
		}catch(e){
			//TODO: Proper error handling
			console.error(e);
		}
	},
	async LOAD_NORMS({ getters, commit }, { vm }){
		if(getters.hasNorms)
			return;

		try{
			const norms = await vm.$json.get("/api/norm/all");
			commit("SET_NORMS", sortedBy(norms, getters.normLabel));
		}catch(e){
			//TODO: Proper error handling
			console.error(e);
		}
	}
};

export default makeModule({
	state,
	getters,
	mutations,
	actions,
})